import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, provideAppInitializer, inject } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { AppComponent } from './app.component'
import { AppRoutingModule } from '@app/app-routing.module'
import { BrowserModule } from '@angular/platform-browser'
import { DeletedScreenComponent } from './components/deleted-screen/deleted-screen.component'
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TitleCasePipe } from '@angular/common'
import { UserPermissionsService } from '@core/user-permissions'
import { AppGlobalErrorHandler } from '@app/services/error-handler.service'
import { WINDOW_PROVIDERS } from '@app/services/window.service'
import { AppLoaderComponent } from '@app/components/app-loader/app-loader.component'
import { PageErrorComponent } from '@app/pages/page-error/page-error.component'
import { LoadingInterceptor } from '@app/services/loading.interceptor'
import { ErrorHandlerInterceptor } from '@app/interfaces/error-handler.interceptor'

function initializeApp(userPermissionsService: UserPermissionsService): Promise<null> {
  return new Promise((resolve) => {
    // get-user-permissions API call sets cookie for anonymous users. It should be the first call.
    firstValueFrom(userPermissionsService.getCurrentValue())
      .then(() => resolve(null))
      .catch(() => resolve(null))
  })
}

@NgModule({
  declarations: [AppComponent],
  imports: [AppRoutingModule, BrowserModule, AppLoaderComponent, DeletedScreenComponent, PageErrorComponent],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    WINDOW_PROVIDERS,
    TitleCasePipe, // TODO: service-level provider (-15.8 khz)
    provideAppInitializer(() => {
      const userPermissionsService = inject(UserPermissionsService)
      return initializeApp(userPermissionsService)
    }),
    {
      provide: ErrorHandler,
      useClass: AppGlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
  ],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
